import { storeSettings } from "@/stores/settings.js";
import $axios from "@/axios";

export default {
  //請求分類
  get: async function () {
    await $axios
      .post("/api/admin/delivery_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeSettings.deliveries = res.data.deliveries;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
